var _mask, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarouselLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.476 6.476 2 12 2s10 4.476 10 10-4.476 10-10 10S2 17.524 2 12Zm2.5 0c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5-3.357 7.5-7.5 7.5A7.499 7.499 0 0 1 4.5 12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.476 6.476 2 12 2s10 4.476 10 10-4.476 10-10 10S2 17.524 2 12Zm2.5 0c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5-3.357 7.5-7.5 7.5A7.499 7.499 0 0 1 4.5 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.924 1 1 5.924 1 12h2c0-4.972 4.028-9 9-9V1Zm11 11c0-6.076-4.924-11-11-11v2c4.972 0 9 4.028 9 9h2ZM12 23c6.076 0 11-4.924 11-11h-2c0 4.972-4.028 9-9 9v2ZM1 12c0 6.076 4.924 11 11 11v-2c-4.972 0-9-4.028-9-9H1Zm11-8.5A8.499 8.499 0 0 0 3.5 12h2A6.5 6.5 0 0 1 12 5.5v-2Zm8.5 8.5A8.5 8.5 0 0 0 12 3.5v2a6.5 6.5 0 0 1 6.5 6.5h2ZM12 20.5a8.5 8.5 0 0 0 8.5-8.5h-2a6.5 6.5 0 0 1-6.5 6.5v2ZM3.5 12a8.5 8.5 0 0 0 8.5 8.5v-2A6.5 6.5 0 0 1 5.5 12h-2Z",
    mask: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.817 8.183a.625.625 0 0 0-.884 0L9.6 11.516a.625.625 0 0 0 0 .884l3.333 3.334a.625.625 0 1 0 .884-.884l-2.892-2.892 2.892-2.891a.625.625 0 0 0 0-.884Z",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeft);
export default __webpack_public_path__ + "static/media/carousel-left.697ba8df.svg";
export { ForwardRef as ReactComponent };